import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import { getCollateralDashboardIcon } from '../common/UtilsIcons'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Icon from 'antd/es/icon'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { CollateralStyles } from './CollateralStyles'
import * as CollateralActions from "../../actions/collateral/CollateralActions"
import { bindActionCreators } from 'redux'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import SearchIcon from '@material-ui/icons/Search'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import { FormControl, Input, InputLabel } from '@material-ui/core'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ClearButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '32px',
    width: '32px',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    color: '#7A9BC2',
    paddingTop: '35px'
}

const CollateralDashboard = ({ classes, ...props }) => {
    const history = useHistory()
    const { match: { params } } = props;
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()
    const [textToFilter, setTextToFilter] = useState('')

    useEffect(() => {
        handleOpenBackdrop()
        props.navigationActions.clean_routes()
        const newRoute = {
            path: '/collateral',
            linkLegend: t('collaterals'),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Dashboard(props.userLanguage, props.userToken, params.branchOfficeId, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = () => {
        if (textToFilter !== '') {
            handleOpenBackdrop()
            props.actions.find_Quadrant(props.userLanguage, props.userToken, params.branchOfficeId, textToFilter, onError, onSuccessFind)
        }
    }

    const onSuccessFind = (response) => {
        handleCloseBackdrop()
        if (response.success) {
            toast.success(response.message, { className: classes.toastSuccess })
        } else {
            toast.info(response.message, { className: classes.toastSuccess })
        }
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const handleIsDiasabled = (stage) => {
        switch (stage) {
            case 'PagoPendiente': return false;
            case 'Finalizacion': return false;
            default: return false;
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <br />
                        <h5>{t('collateral')}</h5>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <FormControl >
                            <InputLabel>{t('collateralDashboard.searchByOt')}</InputLabel>
                            <Input
                                type="text"
                                name="Busqueda de OT"
                                value={textToFilter}
                                onChange={e => setTextToFilter(e.target.value)}
                            />
                        </FormControl>
                        <Tooltip title={t('common.search')}>
                            <IconButton type="button" variant="contained" color="primary" onClick={() => handleSubmit()} style={ClearButton} >
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                        {
                            props.dashboardItems.map((itemDashboard, index) => {
                                return (
                                    <Grid item xs={4} key={index}>
                                        <Card className={classes.borderRadius}>
                                            <CardActionArea disabled={handleIsDiasabled(itemDashboard.stage)} component={RouterLink} to={`/collateral/listByStatus/${itemDashboard.stage}&${params.branchOfficeId}`}>
                                                <CardHeader className={handleIsDiasabled(itemDashboard.stage) === true ? classes.cardHeaderDisabled : classes.cardHeader}
                                                    title={ t(`collateralDashboard.${itemDashboard.stage}`)}
                                                    titleTypographyProps={{ variant: 'h6' }}
                                                />
                                                <CardContent className={classes.dashboardAlign}>
                                                    <Icon type={getCollateralDashboardIcon(itemDashboard.stage)} className={handleIsDiasabled(itemDashboard.stage) === true ? classes.dashboardIconDisabled : classes.dashboardIcon} theme="outlined" />
                                                    <br />
                                                    <br />
                                                    <Grid container item xs={12} className={classes.dashboardAlign}>
                                                        <br />
                                                        <Grid item xs={12} >
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography className={handleIsDiasabled(itemDashboard.stage) === true ? classes.textDisaled : classes.text}>Total</Typography>
                                                            </Grid>
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography className={handleIsDiasabled(itemDashboard.stage) === true ? classes.textDisaled : classes.text}>
                                                                    {
                                                                        handleIsDiasabled(itemDashboard.stage) === true ? 'N/A' : itemDashboard.total
                                                                    }
                                                                    </Typography>
                                                                <br />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                );
                            }
                            )
                        }
                    </Grid>
                    <Grid item xs={12}><br /></Grid>
                </Grid>
            </Container>
            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    dashboardItems: state.CollateralReducer.list,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(CollateralActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CollateralStyles)(CollateralDashboard))
